export const Separator = () => {
  return (
    <hr className="w-full h-[1px] border-wallet-light-inactive dark:border-wallet-inactive" />
  );
};
